export default {"src":"/_next/static/media/sticker-8.185e9b3a.svg","height":74,"width":73,"blurWidth":0,"blurHeight":0};